import i18n from "@/i18n";

/** Idiomas que se envían en `sIdioma`; cualquier otro locale cae a ES. */
const SOAP_IDIOMAS = { es: "ES", en: "EN", fr: "FR", de: "DE", pt: "PT" };

/** Código de idioma para los campos `sIdioma` de los servicios SOAP, según el locale de i18n. */
export function getSoapIdioma() {
  const raw = i18n.global.locale?.value ?? i18n.global.locale ?? "es";
  const code = String(raw).split("-")[0].toLowerCase();
  return SOAP_IDIOMAS[code] ?? "ES";
}
